const REFUND_CHOICES = [
  { type: "WITHOUT_WALLET", label: "Cancel without Refund" },
  { type: "WITH_WALLET", label: "Cancel with Refund" },
];

const WHO_DROPPED = [
  { type: "CUSTOMER_DROPED", label: "Customer dropped" },
  { type: "DELIVERY_BOY_DROPED", label: "Delivery boy dropped" },
  { type: "RESTAURANT_DROPED", label: "Restaurant dropped" },
];

export const isPureCod = (order) => order?.payment?.status === "COD" && Number(order?.wallet_amount) === 0;

export const cancelOptions = (order) => [
  ...(isPureCod(order) ? [{ type: "WITHOUT_WALLET", label: "Cancel order" }] : REFUND_CHOICES),
  ...WHO_DROPPED,
];
